export const voidPayment = ({ token, paymentId }) => ({
  HTTPMethod: "patch",
  path: `/payments/${paymentId}/void`,
  queryParams: {},
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body: {},
});
